import {dispatch, getStore} from 'od-modules/secure_store/store';
import {SET_PRIME_MEMBER_SELECTED, SET_IS_META, SET_CURRENT_PAGE} from 'od-modules/secure_store/actions';
import {getShoppingCartFromDAPI} from 'od-modules/secure_store/reducers/asyncActionCreators';
import {OFFER_TYPES} from 'components/membership/membership_ancillaries/js/constants';
import ShoppingCart from 'od-modules/cart/cart';
var priceCollection = require('od-modules/collections/pricemanager.collection').getInstance();
const ancillariesModuleBaggage = require('../widgets/ancillaries_module/ancillaries_module.collection.bags');
const {loadAtolWidgets} = require('components/atol_protected/js/main');

const AIRPORT_FAST_TRACK = 'AIRPORT_FAST_TRACK';
const FT = 'FT';
const TRAVEL_INSURANCE_TYPE = 'INSURANCE';

(function() {
    'use strict';
    const Fetcher = require('od-modules/utils/fetcher');
    const frontendShell = require('od-modules/frontend-shell');
    const buyerUtils = require('../modules/handlers/buyer');
    const navigate = require('od-modules/frontend-shell/navigate');
    require('../modules/collections/boarding_options/boarding_options.collection').getInstance({load: true});
    const loginFactory = require('components/user_area/login/js/main');
    const createWidgetLoader = require('components-framework/widget/create_widget_loader');
    const DisableWidget = require('../modules/utils/disable_widget');
    const trackingUtils = require('../modules/utils/tracking.utils');
    const xsellUtils = require('od-modules/xsell/utils');
    const tagManagement = require('../modules/utils/tag_management.utils');
    const baggagesCollectionBuilder = require('../modules/builders/baggages').getInstance();
    const baggageTracking = require('../tracking/bags_and_seats/baggage_tracking').getInstance();
    const seatsTracking = require('../tracking/bags_and_seats/seats_tracking').getInstance();
    const paymentGeneric = require('../modules/handlers/paymentpage');
    const ancillariesGeneric = require('../modules/handlers/ancillaries').default;
    const ancillariesStep = require('../modules/handlers/ancillaries_step');
    const serviceOptionsStep = require('../modules/handlers/service_options_step');
    const fieldUtils = require('../modules/utils/field.utils');
    const priceManagerCollection = require('../modules/collections/pricemanager.collection').getInstance();
    const stickySeatsLeftUtils = require('../modules/sticky_seats_left/utils');
    const changeTab = require('../modules/utils/tab_title.utils');
    const myPsd2PopupManagerFactory = require('components/psd2/psd2_popup_manager/js/main');
    const myPsd2CommunicationPopupFactory = require('components/psd2/psd2_communication_popup/js/main');
    const sessionManagement = require('../modules/utils/session.utils');
    const AncillariesModuleGrafanaConstants = require('../widgets/ancillaries_module/ancillaries_module_grafana_constants');
    const ConfirmationHandler = require('../modules/confirm/response_handler');
    const handler3DS = require('../modules/3ds/index').default;
    const trackingPageFlowUtils = require('../modules/utils/flow_tracking/tracking.page.flow.utils');
    const paymentButtonFactory = require('components/payment/payment_button/js/main');
    const cartDebuggerFactory = require('components/cart_debugger/js/main');
    const blockRiskyCardsFactory = require('components/block_risky_cards/js/main');
    const blockExpiringCardsFactory = require('components/block_expiring_cards/js/main');
    const yearlyRejectedCardsFactory = require('components/yearly_rejected_cards/js/main');
    const PB_ITEM_TYPE = require('../modules/enums/pricebreakdown_item_type.enum');
    const {setTabFocusEvent} = require('../modules/utils/tab_manager/dp_shopping_cart_validation');
    const ancillariesSummaryFactory = require('components/ancillaries_summary/js/main');
    const delayCompensationFactory = require('components/delay_compensation/js/main');
    const sidebarFactory = () => Odigeo.AB.sidebarRevamp
        ? import(/* webpackChunkName: "sidebar-factory" */ 'components/sidebar/sidebar_root/js/main')
            .then(({default: factory}) => factory)
        : null;
    const membershipPaymentMethodDisclaimerFactory = () =>
        import(
            /* webpackChunkName: "membership-payment-method-disclaimer" */ 'components/membership/membership_payment_method_disclaimer/js/main'
        ).then(({default: factory}) => factory);
    const {default: membershipAncillaries} = require('components/membership/membership_ancillaries/js/main');
    const {default: membershipRecaptureCustomers} = require('components/membership/membership_recapture_customers/js/main');
    const membershipAutoApplyDiscountFactory = require('components/membership/membership_auto_apply_discount/js/main');
    const Dynpack = require('od-apps/app.dynpack');
    const vinFlightsTracking = require('../tracking/vin_tracking');
    const PAGE = 'payment';
    const {hasRememberMeCookie} = require('od-modules/utils/sso.utils');
    const isUserLogged = () => hasRememberMeCookie();
    const {default: membershipPriceSummary} = require('components/membership/membership_price_summary/js/main');
    const priceSummaryWidget = (widgetLoader) => {
        if (Odigeo.Membership.isMembershipProductEnabledDesktop) {
            widgetLoader.remove('membershipPriceSummary', membershipPriceSummary.WIDGET_NAME);
            widgetLoader.get('membershipPriceSummary').execute('initialize');
        }
    };
    const {revampTrackingLabel} = require('od-modules/utils/membership_tracking.utils').default;
    const membershipService = require('od-modules/secure_store/services/MembershipService').default;
    const membershipAncillariesWidget = (widgetLoader) => {
        if (Odigeo.Membership.isMembershipProductEnabledDesktop) {
            if (Odigeo.Membership.isFreeTrialLimitationActive) {
                widgetLoader.remove('membershipAncillaries', 'membership_ancillaries');
            }
            widgetLoader.get('membershipAncillaries').execute('initialize');
        }
    };

    const membershipRecaptureCustomersWidget = (widgetLoader) => {
        widgetLoader.get('membershipRecaptureCustomers').execute('initialize');
    };

    Odigeo.Router.handlers.payment = function(deeplink) {
        if (Odigeo.AB.isGoBackNativeMessage) {
            window.onbeforeunload = null;
        }
        dispatch(getShoppingCartFromDAPI);
        setDPPricingUtils();
        /* Reexecute `navigate` in frontend-shell to ensure the module is downloaded and payment components executed.
        OF2 platform team to investigate why sometimes frontend-shell is not downloaded.
        NOT A PATTERN TO FOLLOW! */
        navigate(frontendShell, 'payment');
        ancillariesGeneric.initialize();
        Odigeo.Session.remove('resumeBookingStep');

        let cssVisibilityClass = '';
        switch (Odigeo.SessionScope.brand) {
            case 'ED': cssVisibilityClass = 'od-payment-visibility-ed';
                break;
            case 'OP': cssVisibilityClass = 'od-payment-visibility-op';
                break;
            case 'GV':
            case 'GO': cssVisibilityClass = 'od-payment-visibility-go';
                break;
            default: cssVisibilityClass = 'od-payment-visibility-ed';
                break;
        }
        const hasAutoApplyDiscount = Odigeo._.get(getStore(), 'prime.discount.autoApplyDiscount', false);
        const $visibilityHeader = $('#prime_visibility_header');
        if ($visibilityHeader.length) {
            const isLoggedUser = $visibilityHeader.hasClass('prime_visibility_logged_user');
            if ((isLoggedUser || hasAutoApplyDiscount) && window.location.hash &&
                (window.location.hash.indexOf('#payment/') > -1 || window.location.hash.indexOf('#checkout_payment/') > -1)) {
                $visibilityHeader.addClass('od-header-funnel-info-visibility-payment').addClass(cssVisibilityClass);
                $('#bread_crumb_savings_visibility').removeClass('odf-hidden');
            } else {
                $visibilityHeader.removeClass('od-header-funnel-info-visibility-payment').removeClass(cssVisibilityClass);
                $('#bread_crumb_savings_visibility').addClass('odf-hidden');
            }
        }

        const widgets = Odigeo.autoloadWidgets({
            getUsersManager: ['users-manager', 'usersmanager'],
            getBinDetection: ['payment-bin-detection-manager', 'bindetectionmanager'],
            dpWaitingPage: ['dpwaiting-page', 'dp_waiting_page'],
            accommodationDetails: ['accommodation-details', 'accommodation_details'],
            getPaymentManager: ['payment-manager', 'paymentmanager'],
            getPaymentErrorManager: ['payment-error-manager', 'paymenterrormanager'],
            getInvoiceManager: ['invoice-manager', 'invoice_manager'],
            getSpecialrequestManager: ['specialrequest', 'special_request_manager'],
            nagManager: ['nagmanager', 'nagmanager'],
            binDetectionManager: ['payment-bin-detection-manager', 'bin_detection_manager'],
        });

        const bookingid = widgets.getPaymentManager().model.get('bookingId');
        const disableWidget = new DisableWidget(widgets);
        const isDynpack = Odigeo.Utils.isRequestApp('dp');
        const isMktPortal = Odigeo.SessionScope.isMeta;
        const isPrimeActive = Odigeo.Membership.isMembershipProductEnabled;
        const isUpsell = Odigeo.Utils.isRequestApp('upsell');

        function deactivateWidgets() {
            if (Odigeo.AB.isMoveSpecialRequest) {
                disableWidget.deactivate('getSpecialrequestManager');
            }
        }

        deactivateWidgets();
        const isSidebarSummary = $('.side_summary_payment').data('type') === 'sidebarsummary';
        const asyncWidgets = Odigeo.autoloadWidgetsAsync({
            getPriceManagerEnhanced: ['price-breakdown-payments', 'pricemanager_enhanced'],
            getSidebar: isSidebarSummary ? ['sidebar-summary-payment', 'sidebar_summary'] : ['trip-summary-price-payment', 'trip_summary_price'],
            getServiceoptionsTableManager: ['so-table', 'service_options_table'],
            getAncillariesModule: ['ancillaries-module', 'ancillaries_module'],
            getAncillariesDebugInfo: ['ancillaries-debuginfo', 'ancillaries_debuginfo'],
            getHandBaggageSummary: ['hand-baggage-summary', 'hand_baggage_summary'],
            getSeatsLeftOnTop: ['seatsLeftOnTopPaymentPage', 'seats_left_on_top'],
            getBoardingOptions: ['boarding-options', 'boarding_options'],
            getMembershipManager: ['membership-manager', 'membership_manager'],
            getProgressBar: ['progress-bar-3', 'progress_bar'],
            getMembershipPricesTracker: ['membership-prices-tracker', 'membership_prices_tracker'],
            getFlightSummary: ['collapsible-flight-summary-payment', 'collapsible_flight_summary'],
        });
        const widgetLoader = createWidgetLoader({
            login: ['login-header', loginFactory],
            psd2PopupManager: ['psd2-popup-manager', myPsd2PopupManagerFactory],
            psd2CommunicationPopup: ['psd2-communication-popup', myPsd2CommunicationPopupFactory],
            paymentButton: ['payment-button', paymentButtonFactory],
            cartDebugger: ['cart-debugger', cartDebuggerFactory],
            blockRiskyCards: ['block-risky-cards', blockRiskyCardsFactory.default],
            blockExpiringCards: ['block-expiring-cards', blockExpiringCardsFactory.default],
            yearlyRejectedCards: ['yearly-rejected-cards', yearlyRejectedCardsFactory.default],
            paymentSidebar: ['payment_sidebar', sidebarFactory(), {
                page: 'payment',
                isDynpack,
                isUpsell,
                isMktPortal,
                isPrimeActive,
            }],
            membershipPaymentMethodDisclaimer: ['membership_payment_method_disclaimer', membershipPaymentMethodDisclaimerFactory()],
            ancillariesSummary: ['ancillaries-summary', ancillariesSummaryFactory],
            delayCompensation: ['delay-compensation', delayCompensationFactory],
            membershipAncillaries: ['membership-ancillaries', membershipAncillaries.factory],
            membershipRecaptureCustomers: ['membership-recapture-customers', membershipRecaptureCustomers.factory],
            membershipAutoApplyDiscount: ['membership-auto-apply-discount', membershipAutoApplyDiscountFactory],
            membershipPriceSummary: ['membership-price-summary', membershipPriceSummary.factory],
        });
        const $payment = $(`#${PAGE}`);
        const $persuasiveContainer = Odigeo.AB.isCssVariationHeaderDesktop ? $('#header') : $payment;
        const $ccnumber = $payment.find('input[name="ccnumber"]');
        const $priceBreakDownContainer = $payment.find('.price_breakdown_payments_container');
        let hasDataLayerBeenUpdated = false;
        var invoiceData = {};
        const lastRoute = JSON.parse(Odigeo.Session.get('lastRouteChange'));
        const $mainContainer = $('.home_main_layout');
        const appName = isDynpack ? '_DYNPACK_' : '_FLIGHTS_';
        const paymentHandlerResponse = new ConfirmationHandler($payment, widgetLoader, appName);
        const $logo = $('#logo');
        let _submitBinDetectionRequest;
        let validatePassengers;
        let _submitPriceManagerRequest;
        const $ccCardType = $('input[name="cardType"]');
        const $ccNotDetected = $('.cc_not_detected');
        const $persuasionMessagePopup = $payment.find('.persuasion_message_popup');
        const $flightDetails = $payment.find('.flight_details');
        const $persuasiveTitleName = $persuasiveContainer.find('#persuasive_title_name');
        const $persuasiveTitleWithName = $persuasiveContainer.find('.almost_done_with_name');
        const $persuasiveTitleWithoutName = $persuasiveContainer.find('.almost_done_without_name');
        let isPsd2Waiting = false;
        const $page = $('#page');
        const $window = $(window);
        var hasErrors = false;
        const checkPayWithGuaranteePricesTextOnResizeHandler = Odigeo._.throttle(function() {
            asyncWidgets.getPriceManagerEnhanced().execute('checkIfOfferPricesTextSizeShouldBeResized');
        }, 32);
        const $gdprIcon = $page.find('.gdpr_icon');
        let toggleGDPRinfo;
        let onGdprIconClick;
        const PLUS_LOAD_SO_TABLE = 'PLUS_LOAD_SO_TABLE';
        let custom54ValueTotalPrice = 0;
        let readyForTrackingCustom54 = false;
        let hasLaunchTrackingCustomDimension54 = false;
        let scrollPosition = 0;
        let isMembershipSectionFromShell = false;
        const toggleViewPortLock = function(toggle) {
            if (toggle) {
                scrollPosition = $window.scrollTop();
            }
            Odigeo.Device.getViewport().toggleClass('od-viewport-locked', toggle).promise().done(function() {
                if (!toggle) {
                    $window.scrollTop(scrollPosition);
                }
            });
        };

        if ((!Odigeo.AB.isDpSearchInSecure || !Dynpack.isPreparedToLaunchSearchInSecure()) && Dynpack.hasToRedirectFromSecure()) {
            Odigeo.Router.navigate('dpresults_flights', {
                params: Odigeo._.last(Odigeo.History.getFragment().concat(';landingPageType=PASSENGER').split('/')),
            });
            return;
        }

        baggagesCollectionBuilder.buildCollection();

        if (!Odigeo.AB.isMoveSeatsLeftOnTop) {
            if (!Odigeo.AB.isTicketsLeftNextToContinueDetails) {
                stickySeatsLeftUtils.stickyTopSeats($page.find('.seats_left_top_payment'), 'seatsLeftTopStickyPayment');
            }
        }

        validatePassengers = Odigeo._.bind(buyerUtils.validatePassengersManager, this, $page.find('[data-widget="passengers_manager"]'));

        _submitBinDetectionRequest = function(action, data) {
            Odigeo.requireWidget('payment-bin-detection-manager', 'bin_detection_manager', function(bindetectionmanager) {
                bindetectionmanager.execute(action, data);
            });
        };

        _submitPriceManagerRequest = function(action, ccName, ccResolved) {
            asyncWidgets.getPriceManagerEnhanced().execute(action, {
                'ccName': ccName,
                'resolved': ccResolved,
            });

            if (!Odigeo._.isUndefined(ccName)) {
                asyncWidgets.getSidebar().execute('setCcSelected', ccName);
            }
        };

        toggleGDPRinfo = function(e) {
            const $target = $(e.target);
            const gdrPopUpClass = '.gdpr_popup';
            const isGdprIcon = $target.hasClass('od-gdpr-icon');

            const $gdprPopup = (isGdprIcon) ? $target.parent().find(gdrPopUpClass) : $page.find(gdrPopUpClass);

            const isClosed = !$gdprPopup.hasClass('open');
            if (isGdprIcon && isClosed) {
                trackingUtils.trackEvent('sso_pax_page', 'save_paxsnbuyers_details');
            }

            $gdprPopup.toggleClass('open opened', (isGdprIcon) ? isClosed : false);
            e.stopPropagation();
        };

        onGdprIconClick = function(e) {
            toggleGDPRinfo(e);
            $page.one(Odigeo.Events.click, toggleGDPRinfo);
        };

        $gdprIcon.on(Odigeo.Events.click, onGdprIconClick);

        Odigeo.Session.set('page', PAGE);
        Odigeo.Storage.remove('fromContinueButton');
        priceManagerCollection.fetchData();
        membershipAncillariesWidget(widgetLoader);


        const isPrimeRecaptureCustomersDesktop = function() {
            return isPrimeRecaptureCustomersDesktopStore() || Odigeo.Membership.isPrimeRecaptureCustomersDesktop;
        };
        const openLoginForm = Odigeo._.partial(require('../modules/helpers/user.js').openLoginForm, trackingUtils, widgetLoader);

        const isPrimeRecaptureCustomersDesktopStore = function() {
            return Odigeo._.get(getStore(), 'prime.membershipSubscriptionDetails.reactivatePrime', false);
        };

        Fetcher.get('/travel/service/membership/is-membership-section-from-shell').json().then((isMembershipSectionFromShellResponse) => {
            isMembershipSectionFromShell = isMembershipSectionFromShellResponse;
            const $container = $payment.find('#subscription-manager-desktop-container');
            $container.empty();
            if (isMembershipSectionFromShell) {
                $container.append('<div id="membership-section"></div>');
            }

            if (isPrimeRecaptureCustomersDesktop() && !isMembershipSectionFromShell) {
                membershipRecaptureCustomersWidget(widgetLoader);
            } else {
                trackingUtils.trackEventWithCategory('flights_ancillaries_page', 'prime_renewal', 'prime-renewal_off_pag:anc');
            }

            ancillariesStep.setIsPrimeModuleFromShell(isMembershipSectionFromShell);
            ancillariesGeneric.setIsPrimeModuleFromShell(isMembershipSectionFromShell);
        });

        const editMembershipSubscription = (action) => {
            widgetLoader.get('membershipAncillaries').execute(action);
        };

        const triggerMembershipProductRisk = (risk) => {
            return frontendShell.execute(({evaluateMembershipProduct}) => {
                evaluateMembershipProduct.evaluate(risk);
            });
        };

        $.extend(
            true,
            Odigeo.Router.eventController,
            Odigeo.Router.handlers.userEventController,
            Odigeo.Router.handlers.repriceManagerEventController,
            Odigeo.Router.handlers.globalEventController,
            Odigeo.Router.handlers.errorManagerEventController,
            {
                globalEvents: {
                    'dpsearch-manager:retryDynpackDeeplink': 'retryDynpackDeeplink',
                },
                viewEvents: Odigeo._.extend(
                    paymentGeneric.viewEvents(),
                    ancillariesGeneric.viewEvents(),
                    paymentHandlerResponse.confirmationEvents(),
                    {
                        'payment-error-manager:sendValidationErrors': 'sendValidationErrors',
                        'dpwaiting-page:cleanDpWaitingPage': 'cleaningDpWaitingPage',
                        'dpwaiting-page:hidePageOverDpWaitingPage': 'hiddenPageOverDpWaitingPage',
                        'drawer-generic:toggleViewPortLock': 'onToggleViewPortLock',
                        'invoice-manager:clearValidationErrors': 'onInvoiceManagerClearValidationErrors',
                        'invoice-manager:showErrorsResume': 'onShowInvoiceManagerErrorsResume',
                        'payment-bin-detection-manager:creditCardTypeChanged': 'onCreditCardChanged',
                        'payment-bin-detection-manager:methodTypeChanged': 'onCcMethodTypeSelected',
                        'payment-bin-detection-manager:showPaymentMethodDisclaimer': 'onShowPaymentMethodDisclaimer',
                        'payment-bin-detection-manager:showCCDropdown': 'onShowCCDropdown',
                        'payment-bin-detection-manager:showPsd2InfoMsg': 'onShowPsd2InfoMsg',
                        'payment-bin-detection-manager:checkRiskyCard': 'onCheckRiskyCard',
                        'payment-manager:confirmationLoading': 'onConfirmationLoading',
                        'payment-manager:confirmError': 'onConfirmationError',
                        'payment-manager:noPaymentMethodsAvailable': 'onNoPaymentMethodsAvailable',
                        'payment-manager:paymentMethodChanged': 'onPaymentMethodChanged',
                        'payment-manager:paymentOptionsUpdated': 'onCreditCardListReady',
                        'payment-manager:ready': 'onPaymentManagerReady',
                        'payment-manager:showErrors': 'onShowErrors',
                        'payment-manager:showErrorsResume': 'onShowPaymentErrorsResume',
                        'payment-manager:updateCardMethod': 'onUpdateCardMethod',
                        'payment-manager:expirationDateChange': 'onExpirationDateChange',
                        'payment-manager:checkExpiringCard': 'onCheckExpiringCard',
                        'payment-manager:creditCardTypeChanged': 'onCreditCardChanged',
                        'payment-manager:hideBlockingBinsSuccessMessage': 'onHideBlockingBinsSuccessMessage',
                        'passengers_manager:completed': 'onPassengerPageComplete',
                        'psd2-popup-manager:psd2PopUpClosed': 'onPsd2WaitingClosed',
                        'psd2-popup-manager:psd2PopUpOpen': 'onPsd2WaitingOpen',
                        'global:repricingShown': 'onRepricing',
                        'share-itinerary-payment:onShareEmailSearch': 'onShareEmailSearch',
                        'ancillariesStep:opened': 'onAncillariesStepOpened',
                        'ancillaries_module:ancillaryProductRendered': 'onAncillaryProductRendered',
                        'shoppingcart-manager:enablePaymentButton': 'enablePaymentButton',
                        'error-message-layer:tryAgain': 'goToPayment',
                        'price-breakdown-payments:onContinueButtonClicked': 'onContinueButtonClicked',
                        'sidebar-summary-payment:openFlightDetails': 'onOpenFlightDetails',
                        'sidebarFlightInfo:changeDPSelection': 'sendUserToDpResults',
                        'trip-summary-price-payment:sendUserToDpResults': 'sendUserToDpResults',
                        'sidebar-summary-payment:sendUserToDpResults': 'sendUserToDpResults',
                        'price-breakdown-payments:updateSummaryPrices': 'onUpdateSummaryPrices',
                        'price-breakdown-payments:updatePremiumSidebarView': 'onUpdatePremiumSidebarView',
                        'price-breakdown-payments:totalPriceUpdated': 'totalPriceUpdated',
                        'price-breakdown-payments:updatePricesTripSummary': 'onUpdatePrices',
                        'price-breakdown-payments:toggleCcType': 'onToggleCcType',
                        'membership:priceMemberDisplay': 'onPriceMemberDisplay',
                        'boarding-options:boardingOptionsLoaded': 'onBoardingOptionsLoaded',
                        'ancillaries_module:selectionChanged': 'ancillaryOfferSelectionChanged',
                        'so-table:updatedServiceOptions': 'soTableUpdatedServiceOptions',
                        'shoppingcart-manager:requestError': 'onSCManagerRequestError',
                        'pay-with-guarantee:setPayWithGuaranteeTrackingConditionsData': 'setPayWithGuaranteeTrackingConditionsData',
                        'flight-details:showFlightDetails': 'onShowFlightDetails',
                        'payment-button:onContinueWithProductAttached': 'onContinueWithProductAttached',
                        'payment-button:hideTotalPriceContainer': 'hideTotalPriceContainer',
                        'payment-button:checkPaymentFormIsValidAndAgreed': 'checkPaymentFormIsValidAndAgreed',
                        'sidebar-summary-payment:getMembershipInfo': 'onGetMembershipInfo',
                        'payment-manager:openPsd2Communication': 'onOpenPsd2Communication',
                        'membership-auto-apply-discount:isAutoApplyDiscount': 'onIsAutoApplyDiscount',
                        'membership-ancillaries:scrollToRiskyCardWarningMessage': 'onScrollToRiskyCardWarningMessage',
                        'membership-ancillaries:scrollToExpiringCardWarningMessage': 'onScrollToExpiringCardWarningMessage',
                        'membership-ancillaries:checkRiskyCard': 'onCheckRiskyCard',
                        'membership-ancillaries:shouldRequestForRiskyCardNumber': 'onShouldRequestForRiskyCardNumber',
                        'membership-ancillaries:showMembershipPaymentMethodDisclaimer': 'onShowMembershipPaymentMethodDisclaimer',
                        'block-risky-cards:riskyCreditCardDetected': 'onRiskyCreditCardDetected',
                        'block-risky-cards:riskyCreditCardCleared': 'onRiskCleared',
                        'block-risky-cards:evaluateYearlySubscription': 'onEvaluateYearlySubscription',
                        'block-risky-cards:scrollToRiskyCardWarningMessage': 'onScrollToRiskyCardWarningMessage',
                        'yearly-rejected-cards:yearlyRejectedChange': 'onYearlyRejectedChange',
                        'block-expiring-cards:blockingBinDetected': 'onBlockingBinDetected',
                        'block-expiring-cards:blockingBinCleared': 'onRiskCleared',
                        'sidebarHotelInfo:removeHotel': 'showRemoveHotelNag',
                        'shoppingcart-manager:successDeleteHotelFromCart': 'onSuccessDeleteHotelFromCart',
                        'price-section-payment:trackCustomDimensionSidebar': 'onTrackCustomDimensionSidebar',
                        'frontend-shell:fareSelectedSubscription': 'onFareSelectedSubscription',
                        'frontend-shell:openLoginPopup': 'onOpenLoginPopup',
                        'frontend-shell:membershipSectionContinue': 'onMembershipSectionContinue',
                        'frontend-shell:membershipSectionCollapseBack': 'onMembershipSectionCollapseBack',
                        'refresh-membership-subscription:success': 'onRefreshMembershipSubscriptionSuccess',
                        'frontend-shell:fast-track:toggle': 'onFastTrackToggle',
                        'frontend-shell:frontend-guarantees:onToggle': 'onCanxselfToggleOF2',
                        'frontend-shell:frontend-insurances:onTravelInsuranceSelectionChange': 'onTravelInsuranceSelectionChangeOF2',
                    }
                ),
                eventHandlers: Odigeo._.extend(paymentGeneric.eventHandlers(), ancillariesGeneric.eventHandlers(), {
                    showRemoveHotelNag: function(imgUrl) {
                        xsellUtils.showRemoveHotelNag(
                            imgUrl,
                            this.removeHotelFromRemoveHotelNag.bind(this),
                            this.changeHotelFromRemoveHotelNag.bind(this)
                        );
                        trackingUtils.trackEvent('trip_information', 'remove_hotel');
                    },
                    onMembershipSectionContinue() {
                        ancillariesStep.onContinueToPaymentEvent();
                    },
                    onMembershipSectionCollapseBack() {
                        ancillariesStep.onCollapsePaymentForm();
                    },
                    onOpenLoginPopup: openLoginForm,
                    changeHotelFromRemoveHotelNag: function() {
                        this.removeHotelFromRemoveHotelNag(true);
                        trackingUtils.trackEvent('nags', 'remove_hotel_change');
                    },
                    onRefreshMembershipSubscriptionSuccess() {
                        priceManagerCollection.fetchData();
                        tagManagement.updateDatalayer();
                        widgets.getPaymentManager().execute('updatePaymentOptions');
                    },
                    onFareSelectedSubscription() {
                        membershipService.refreshMembershipSubscription(dispatch);
                    },
                    removeHotelFromRemoveHotelNag: function(isChangeHotel) {
                        if (!isSidebarSummary) {
                            asyncWidgets.getSidebar().execute('disableRemoveHotel');
                        }
                        xsellUtils.removeHotelFromShoppingCart(isChangeHotel);
                        const $removeHotelNag = $('.remove_hotel_nag');
                        $removeHotelNag.find('.dialog_content_container').removeClass('odf-hidden');
                        $removeHotelNag.find('.dialog_footer, .dialog_post_footer').addClass('odf-hidden');
                    },
                    onSuccessDeleteHotelFromCart: function(isChangeHotel) {
                        Odigeo.Session.set('deletedHotelFromCart', 'true');
                        if (!isChangeHotel) {
                            window.location.reload();
                        } else {
                            this.sendUserToDpResults('accommodation', true);
                        }
                    },
                    onCheckRiskyCard: (creditCardBinNumber, forceUpdate = false) => {
                        widgetLoader.get('blockRiskyCards').execute('checkRiskyCard', creditCardBinNumber, forceUpdate);
                    },
                    onScrollToRiskyCardWarningMessage: () => {
                        widgetLoader.get('blockRiskyCards').execute('scrollToWarningMessage');
                    },
                    onShouldRequestForRiskyCardNumber: (offerSelected) => {
                        const shouldRequestForRiskyCardNumber = $ccnumber && $ccnumber.val() && offerSelected === OFFER_TYPES.PRIME_FARE;
                        shouldRequestForRiskyCardNumber &&
                            widgetLoader.get('membershipAncillaries').execute('shouldRequestForRiskyCardNumber', $ccnumber.val());
                    },
                    onShowMembershipPaymentMethodDisclaimer: (offerSelected) => {
                        widgetLoader.get('membershipPaymentMethodDisclaimer').execute('showDisclaimer', offerSelected === OFFER_TYPES.PRIME_FARE);
                    },
                    onBlockingBinDetected: () => {
                        return isMembershipSectionFromShell
                            ? triggerMembershipProductRisk('BLOCKING_BIN')
                            : editMembershipSubscription('removePrime');
                    },
                    onRiskCleared: () => {
                        return isMembershipSectionFromShell ? triggerMembershipProductRisk('NO_RISK') : editMembershipSubscription('addPrime');
                    },
                    onRiskyCreditCardDetected: () => {
                        return isMembershipSectionFromShell
                            ? triggerMembershipProductRisk('RISKY_CREDIT_CARD')
                            : editMembershipSubscription('removePrime');
                    },
                    onEvaluateYearlySubscription: (binNumber) => {
                        const shoppingCart = getStore()?.shoppingCart?.shoppingCart || {};
                        const membershipSubscriptionShoppingItems = Odigeo._.get(shoppingCart,
                            'otherProductsShoppingItems.membershipSubscriptionShoppingItems', []);
                        const offerId = membershipSubscriptionShoppingItems.length > 0 ? membershipSubscriptionShoppingItems[0]?.offerId || '' : '';
                        const binNumberPrefix = binNumber ? binNumber.slice(0, 6) : '';
                        widgetLoader.get('yearlyRejectedCards').execute('checkYearlyRejectedCards', binNumberPrefix, offerId);
                    },
                    onYearlyRejectedChange: (isYearlyRejected, binNumber) => {
                        return isYearlyRejected
                            ? triggerMembershipProductRisk({membershipEvaluationCode: 'YEARLY_REJECTED', creditCardBin: binNumber})
                            : triggerMembershipProductRisk('NO_RISK');
                    },
                    onCheckExpiringCard: ($el) => {
                        const name = $el.attr('name');
                        const value = $el.val();
                        if (name === 'cardExpirationMonth' || name === 'cardExpirationYear') {
                            widgetLoader.get('blockExpiringCards').execute('checkExpiringCard', {[name]: value});
                        }
                    },
                    onScrollToExpiringCardWarningMessage: () => {
                        widgetLoader.get('blockExpiringCards').execute('scrollToWarningMessage');
                    },
                    retryDynpackDeeplink: () => {
                        Odigeo.Router.navigate('details', {
                            params: Odigeo._.last(Odigeo.History.getFragment().split('/')),
                        });
                    },
                    onUserInteractionNeeded: (data) => {
                        handler3DS.sendLogToKibana(`CONFIRMATION_3DSECURE_COUNTER_${bookingid}`, '_FLIGHTS_');
                        handler3DS.composePsd2Metric('3DS_TIME_ERROR', '_FLIGHTS_', 'startMetric');
                        handler3DS.composePsd2Metric('3DS_TIME', '_FLIGHTS_', 'startMetric');
                        paymentHandlerResponse.onUserInteractionNeeded(data);
                    },
                    onBookingConfirmedLoaded: (data) => paymentHandlerResponse.onBookingConfirmedLoaded(data),
                    onBookingError: (data) => paymentHandlerResponse.onBookingError(data),
                    onBookingPaymentRetryLoaded: (data) => paymentHandlerResponse.onBookingPaymentRetryLoaded(data),
                    onPaymentMethodsUpdated: (data) => paymentHandlerResponse.onPaymentMethodsUpdated(data),
                    onRetryCreditCard: (data) => paymentHandlerResponse.onRetryCreditCard(data),
                    onRetryDifferentMethod: (data) => paymentHandlerResponse.onRetryDifferentMethod(data),
                    onBookingRepricingLoaded: (data) => paymentHandlerResponse.onBookingRepricingLoadedDesktop(data, $priceBreakDownContainer),
                    // This event accepts either an array of error objects or a single error object in the following
                    // format: {type: '', validationResult: ''}
                    ancillaryOfferSelectionChanged: function(data) {
                        widgetLoader.get('paymentButton').execute('storeProductSelection', data, (model) => {
                            asyncWidgets.getPriceManagerEnhanced().execute('hideTotalPriceContainer', model.mustHideTotalPrice);
                        });
                    },
                    soTableUpdatedServiceOptions(type, selected) {
                        widgetLoader.get('paymentButton').execute('storeProductSelection', {
                            id: type,
                            pbdType: PB_ITEM_TYPE.SERVICE_OPTIONS,
                            selected,
                        });
                    },
                    onSCManagerRequestError: function() {
                        Odigeo.UIElements.enhanceLoading($('.waiting_page')).hideLoading();
                    },
                    onOpenFlightDetails: function(event, hasToTrack) {
                        Odigeo.requireWidget('flight-details-payments', 'flight_details', function(flightDetails) {
                            flightDetails.execute('toggleViewPanel', event, hasToTrack);
                        });
                    },
                    onPriceMemberDisplay: function(action) {
                        asyncWidgets.getSidebar().execute('updatePriceMemberDisplay', action);
                    },
                    onUpdateSummaryPrices: async function() {
                        var updatePrices = isSidebarSummary ? 'refreshPrice' : 'updatePrices';
                        asyncWidgets.getSidebar().execute(updatePrices);
                        const isSubscriptionAdded = this.isSubscriptionAdded();
                        widgetLoader.get('membershipPriceSummary').execute('onChangeOffer', isSubscriptionAdded);
                    },
                    onUpdatePremiumSidebarView: function(membershipPerks) {
                        asyncWidgets.getSidebar().execute('updatePremiumSidebarView', membershipPerks);
                        if (Odigeo.Membership.isMembershipFlexibilityD && membershipPerks.isMemberLoggedIn) {
                            ancillariesStep.toggleMembershipFlexibility(membershipPerks.isMemberLoggedIn);
                        }
                    },
                    onToggleCcType: function(show) {
                        asyncWidgets.getSidebar().execute('toggleCcType', show);
                    },
                    onUpdatePrices: function(data) {
                        asyncWidgets.getSidebar().execute('updatePrices', data);
                    },
                    onBoardingOptionsLoaded: function(data) {
                        asyncWidgets.getHandBaggageSummary().execute('storeBoardingOptions', data);
                        asyncWidgets.getSidebar().execute('updateHandBaggageView', data);
                    },
                    onCcMethodTypeSelected: function(ccName) {
                        var paymentManager = widgets.getPaymentManager();
                        if (paymentManager.model.get('chosenMethod') === 'CREDITCARD') {
                            _submitPriceManagerRequest('showCcSelected', ccName);
                        }
                    },
                    sendUserToDpResults: function(product, isIntermediatePage) {
                        if (isIntermediatePage) {
                            product === 'accommodation' ? xsellUtils.navigateToNonSecure('xsellproductselection') : Odigeo.Router.navigate('results');
                        } else {
                            const page = product === 'accommodation' ? 'dpresults_accommodation' : 'dpresults_flights';

                            Odigeo.Session.set('DynPackActiveProduct', product);
                            Odigeo.Router.navigate(page, {
                                params: deeplink,
                            });
                        }
                    },
                    onContinueButtonClicked(id, options = {}) {
                        trackingUtils.startMetric('LOAD_CONFIRM_DESKTOP');
                        trackingUtils.counterMetric('FRONT' + appName + 'PAYMENT_CLICK_COUNTER');
                        validatePassengers($payment);
                        asyncWidgets.getBoardingOptions().execute('trackContinueToConfirmation');

                        const {validationResolve = () => {}} = options;
                        const isFormValid = this.validatePaymentPage();

                        validationResolve(isFormValid);

                        if (isFormValid) {
                            trackingUtils.counterMetric('FRONT' + appName + 'PAYMENT_VALIDATION_OK_COUNTER');

                            baggageTracking.trackBaggagePayContinuance();
                            seatsTracking.trackSeatsContinuance('pay');

                            this.sendSuccessPurchaseTracking(options);
                            this.trackRepricingClose(Odigeo.Session.get('repricingClose'));
                        } else {
                            this.sendFailPurchaseTracking(options);
                            trackingUtils.counterMetric('FRONT' + appName + 'PAYMENT_VALIDATION_KO_COUNTER');
                            this.showPaymentValidationErrors();
                        }

                        const isPrimeWidgetDecisionTaken = this.isPrimeWidgetDecisionTaken();
                        if (isFormValid && isPrimeWidgetDecisionTaken) {
                            widgetLoader.get('psd2PopupManager').execute('toggleWaiting', true);
                            ancillariesGeneric.continueTo();
                        } else {
                            this.onPsd2WaitingClosed();
                        }
                    },
                    async isPrimeWidgetDecisionTaken() {
                        let isPrimeWidgetDecisionTaken = true;
                        if (Odigeo.Membership.isMembershipProductEnabled && !isMembershipSectionFromShell) {
                            const isShowPendingDecisionBanner = widgetLoader
                                .get('membershipAncillaries')
                                .get('toggleShowPendingPrimeDecisionMessage');
                            const isAutoApplyDiscount = await widgetLoader.get('membershipAutoApplyDiscount').get('isAutoApplyDiscount');
                            isPrimeWidgetDecisionTaken = !isShowPendingDecisionBanner || isAutoApplyDiscount;
                        }
                        return isPrimeWidgetDecisionTaken;
                    },
                    sendSuccessPurchaseTracking({onSuccessPurchaseTracking = () => {}}) {
                        onSuccessPurchaseTracking();
                    },
                    sendFailPurchaseTracking({onFailPurchaseTracking = () => {}}) {
                        onFailPurchaseTracking();
                    },
                    trackRepricingClose(repricingClose) {
                        if (repricingClose) {
                            trackingUtils.trackEvent('repricing_popup', repricingClose);
                        }
                    },
                    goToPayment: function() {
                        var offset = $('#payment-manager').offset().top - 10 + 'px';
                        this.onScrollTo(offset, 100);
                    },
                    onPsd2WaitingClosed: () => {
                        isPsd2Waiting = false;
                        widgetLoader.get('paymentButton').execute('togglePaymentBtn', isPsd2Waiting);
                    },
                    onPsd2WaitingOpen: () => {
                        isPsd2Waiting = true;
                        widgetLoader.get('paymentButton').execute('togglePaymentBtn', isPsd2Waiting);
                    },
                    enablePaymentButton: function() {
                        if (!isPsd2Waiting) {
                            widgetLoader.get('paymentButton').execute('togglePaymentBtn', true);
                        }
                    },
                    onAncillaryProductRendered: function(ancillaryModel) {},
                    hideTotalPriceContainer(mustHide) {
                        asyncWidgets.getPriceManagerEnhanced().execute('hideTotalPriceContainer', mustHide);
                    },
                    async onContinueWithProductAttached(options = {}) {
                        const {
                            productId,
                            widgetSelector = () => ({
                                execute: () => {},
                            }),
                            onSuccessCallback = () => {},
                        } = options;
                        trackingUtils.counterMetric(`FRONT${appName}PAYMENT_CLICK_COUNTER`);
                        validatePassengers($payment);
                        const isPrimeWidgetDecisionTaken = this.isPrimeWidgetDecisionTaken();

                        if (this.validatePaymentPage() && isPrimeWidgetDecisionTaken) {
                            widgetLoader.get('psd2PopupManager').execute('toggleWaiting', true);

                            trackingUtils.counterMetric(`FRONT${appName}PAYMENT_VALIDATION_OK_COUNTER`);
                            widgetSelector(asyncWidgets)
                                .execute('toggleAncillaryOfferIfExists', productId, true)
                                .then(() => {
                                    onSuccessCallback();
                                });
                        } else {
                            this.onFormValidationError(options);
                        }
                    },
                    onFormValidationError({onErrorCallback = () => {}} = {}) {
                        const paymentManager = widgets.getPaymentManager();
                        const isIdealRequestValid = paymentManager.get('isIdealRequestValid');
                        if (isIdealRequestValid) {
                            trackingUtils.counterMetric(`FRONT${appName}PAYMENT_VALIDATION_KO_COUNTER`);
                            this.showPaymentValidationErrors();
                            onErrorCallback();
                        }
                        trackingUtils.counterMetric(`FRONT${appName}PAYMENT_VALIDATION_KO_COUNTER`);
                        this.showPaymentValidationErrors();
                        onErrorCallback();
                    },
                    checkPaymentFormIsValidAndAgreed(callback = () => {}) {
                        const paymentManager = widgets.getPaymentManager();
                        const isIdealRequestValid = paymentManager.get('isIdealRequestValid');
                        const isValid = isIdealRequestValid ? this.validatePaymentPage() : false;
                        const onFormValidationError = this.onFormValidationError.bind(this);
                        if (isValid) {
                            if (isPrimeRecaptureCustomersDesktop() && !isMembershipSectionFromShell) {
                                widgetLoader.get('membershipRecaptureCustomers').execute('triggerTrackingOnPayment');
                            }
                            revampTrackingLabel('continuePaymentButton');
                        }
                        callback(
                            new Promise((resolve, _) => {
                                if (!isValid && isIdealRequestValid) {
                                    onFormValidationError();
                                }

                                resolve(isValid);
                            })
                        );
                    },
                    onAncillariesStepOpened: async function() {
                        ancillariesGeneric.onTrackContinue('ancillaries');
                        if (!Odigeo.AB.isMetaAncillariesPageActive) {
                            asyncWidgets.getProgressBar().execute('setPaymentState', 3);
                        }
                        if (Odigeo.Membership.isMembershipProductEnabled && !isMembershipSectionFromShell) {
                            const isShowPendingDecisionBanner = widgetLoader
                                .get('membershipAncillaries')
                                .get('toggleShowPendingPrimeDecisionMessage');
                            if (!isShowPendingDecisionBanner) {
                                this.membershipAncillariesTracking(false);
                            }
                        }
                        if (isPrimeRecaptureCustomersDesktop() && !isMembershipSectionFromShell) {
                            const isShowingRecapturePendingDecisionMsg = await widgetLoader
                                .get('membershipRecaptureCustomers')
                                .get('togglePendingMembershipReactivateDecisionMessage');
                            if (!isShowingRecapturePendingDecisionMsg) {
                                widgetLoader.get('membershipRecaptureCustomers').execute('handleOnContinueSuccess');
                            }
                        }
                    },
                    setPayWithGuaranteeTrackingConditionsData: function(data) {
                        asyncWidgets.getPriceManagerEnhanced().execute('setPayWithGuaranteeTrackingConditionsData', data);
                    },
                    setPolicy: function(data) {
                        asyncWidgets.getPriceManagerEnhanced().execute('setPolicy', data);
                    },
                    hidePayWithGuarantee: function() {
                        asyncWidgets.getPriceManagerEnhanced().execute('hidePayWithGuarantee');
                        $window.off('resize', checkPayWithGuaranteePricesTextOnResizeHandler);
                    },
                    showPayWithGuarantee: function() {
                        asyncWidgets.getPriceManagerEnhanced().execute('showPayWithGuarantee');
                        this.refreshOfferPricesTextSize();

                        $window.on('resize', checkPayWithGuaranteePricesTextOnResizeHandler);
                    },

                    onToggleViewPortLock: function(value) {
                        toggleViewPortLock(value);
                    },

                    sendValidationErrors: function(errors) {
                        widgets.getPaymentErrorManager().execute('updateErrorsCollection', errors);
                    },
                    onShareEmailSearch: function(evt, data) {
                        Odigeo.requireWidget('share-selection', 'share_selection', function(widget) {
                            widget.execute('setShareSelectionEl', evt.currentTarget);
                            widget.execute('reset', data);
                        });
                    },
                    onConfirmationLoading: function() {
                        $logo.addClass('disabled');
                        Odigeo.Session.remove('before-page');
                    },
                    onConfirmationError(status) {
                        paymentHandlerResponse.confirmationError(status, isDynpack);
                    },
                    commitPayment: function(paymentManager) {
                        ancillariesGeneric.commitPayment(paymentManager);
                    },
                    onCreditCardChanged: function(ccType, ccName, ccResolved, showCCDropdown) {
                        if (!!ccType && ccType !== '-1') {
                            widgets.getPaymentManager().execute('setCreditCardType', ccType, showCCDropdown);
                        }
                        var paymentManager = widgets.getPaymentManager();
                        if (paymentManager.model.get('chosenMethod') === 'CREDITCARD') {
                            _submitPriceManagerRequest('showCcSelected', ccName, ccResolved);
                        }

                        if (!isSidebarSummary) {
                            asyncWidgets.getSidebar().execute('setCcSelected', ccName);
                        }
                    },
                    onHideBlockingBinsSuccessMessage() {
                        widgetLoader.get('blockRiskyCards').execute('hideBlockingBinsSuccessMessage');
                    },
                    onShowPaymentMethodDisclaimer: function(data) {
                        _submitPriceManagerRequest('showPaymentMethodDisclaimer', data.ccName, data.resolved);
                    },
                    onShowCCDropdown(showCCDropdown) {
                        widgets.getPaymentManager().execute('showCCDropdown', showCCDropdown);
                    },
                    onRepricing: function() {
                        Odigeo.requireWidget('payment-page-top-persuasive-message', 'persuasiveMessaging', function(persuasiveMessaging) {
                            persuasiveMessaging.execute('closeMessage');
                        });

                        widgetLoader.get('paymentButton').execute('forceLoad');
                    },
                    onPaymentMethodChanged: function(method) {
                        if (method !== 'CREDITCARD') {
                            _submitPriceManagerRequest('showCcSelected', '');
                        } else {
                            _submitBinDetectionRequest('getCcSelectedName');
                        }
                        widgets.getPaymentManager().execute('updateFees');
                        readyForTrackingCustom54 = true;
                    },
                    onCreditCardListReady: function(ccList) {
                        _submitBinDetectionRequest('setCCFees', ccList);
                    },
                    onPaymentManagerReady: function() {
                        // enhance payment creditcard expiration
                        var ccExpiration = Odigeo.UIElements.enhanceDateWithSelects($('#ccExpiration'), {yearLimit: 2050});

                        if (!Odigeo.AB.isNewNewsletterLogic) {
                            Odigeo.requireWidget('gdpr-newsletter', 'gdpr_newsletter', function(gdprNewslettermanager) {
                                const passengersData = Odigeo.Utils.parseJson(Odigeo.Session.get('passengersData'));

                                if (passengersData) {
                                    gdprNewslettermanager.execute('setNewsletterEmail', passengersData.buyer.mail);
                                }
                            });
                        }

                        widgets.getPaymentManager().execute('enhancedElementList', {
                            uielement: 'ccExpiration',
                            element: ccExpiration,
                        });
                        Odigeo.UIElements.enhanceDateWithSelects($('#cnBirthDate'), {yearLimit: 1910});

                        asyncWidgets.getPriceManagerEnhanced().execute('reloadPrices');

                        if (!isSidebarSummary) {
                            asyncWidgets.getSidebar().execute('fillPax');
                        }

                        Odigeo.requireWidget('flight-details-payments', 'flight_details', function(widget) {
                            widget.execute('refreshPaxData');
                        });

                        Odigeo.Utils.sessionTimer.reset();

                        this.trackMembershipInfo();

                        if (!hasDataLayerBeenUpdated) {
                            const customDimensions = {
                                customDimensions: {
                                    transaction_price: '' + custom54ValueTotalPrice,
                                },
                            };
                            const config = Object.assign(
                                {
                                    legacy: Odigeo.Utils.getFunnelTrackingLegacy() + 'pago/',
                                    funnel: true,
                                },
                                custom54ValueTotalPrice ? customDimensions : null
                            );
                            trackingUtils.trackPage(PAGE, config);
                            tagManagement.updateDatalayer();
                            hasDataLayerBeenUpdated = true;
                        }

                        $payment.removeClass('hidden');

                        Odigeo.UIElements.enhanceLoading($('.waiting_page')).hideLoading();

                        widgetLoader.get('membershipPaymentMethodDisclaimer').execute('showDisclaimer');

                        $payment
                            .find('.paypal_info_hint')
                            .off()
                            .on(Odigeo.Events.tap, function(e) {
                                e.preventDefault();
                                window.open($(e.target).data('url'), '_blank', 'scrollbars=1,resizable=1,height=300,width=450');
                            });

                        $payment
                            .find('.toggle_account_creation_terms').addClass('odf-text-underline')
                            .off()
                            .on(Odigeo.Events.tap, function(e) {
                                e.preventDefault();
                                $payment.find('.personal_acount_rejection_disclaimer').removeClass('odf-hidden');
                                const setToastTimeout = setTimeout(runToastTimeout, 3000);
                                function runToastTimeout() {
                                    $payment.find('.personal_acount_rejection_disclaimer').addClass('odf-hidden');
                                    clearTimeout(setToastTimeout);
                                }
                                Odigeo.Utils.scrollToElement('.personal_acount_rejection_disclaimer');
                                Odigeo.Session.set('accountCreationEnabled', false);
                            });

                        // Deactivate dynpack waiting page
                        if (isDynpack) {
                            widgets.dpWaitingPage().execute('deactivate');
                            setFocusEventWindowMultitab(bookingid);
                        }
                        Odigeo.Utils.patchFormsForiOS8($payment);

                        if (widgets.getPaymentManager().isPaymentMethodRetry || widgets.getPaymentManager().isRepricing) {
                            widgets.getPaymentManager().isRepricing = false;
                        }
                        // reset paymentMethodRetryFlag
                        widgets.getPaymentManager().isPaymentMethodRetry = false;

                        var error = widgets.getPaymentManager().error;
                        // In case we come from confirmation we check if there's an error and we show it
                        if (!Odigeo._.isUndefined(error) && !Odigeo._.isNull(error)) {
                            widgets.getPaymentErrorManager().execute('updateErrorsCollection', error).execute('scrollToError');
                            widgets.getPaymentManager().error = null;
                        }

                        if (Odigeo.Utils.isRequestApp('dp') || Odigeo.Utils.isRequestApp('upsell')) {
                            Odigeo.trigger('reprice-manager:checkRepricing', '#repricing-notification-payment');
                        }

                        // load shortPaxInfo.jsp into pax_info_table_details
                        ancillariesGeneric.tablePaxDetails('flight-details-payments');
                        widgetLoader.get('paymentButton').execute('toggleButtons', false);
                        priceSummaryWidget(widgetLoader);
                    },

                    onUpdateCardMethod: function() {
                        // when users update any info the tooltip must be hidden
                        $('.payment_method_remember_tooltip').addClass('hidden');
                    },
                    onShowPaymentErrorsResume: function(errorList) {
                        var errorTxt = '';
                        var $errorContainer = $payment.find('.paymentmanager_validation_errors');
                        if (!Odigeo._.isUndefined(errorList) && Odigeo._.keys(errorList).length > 0) {
                            if (!$ccNotDetected.hasClass('hidden') && $ccCardType.val() === '-1') {
                                errorList.cardType = 'empty';
                            }
                            Odigeo._.each(errorList, function(errorType, inputName) {
                                var txt;
                                var inputNameSelector =
                                    {
                                        creditCardExpiration: 'cardExpirationMonth',
                                    }[inputName] || inputName;
                                var $selector = $('input[name=' + inputNameSelector + '], select[name=' + inputNameSelector + ']');
                                if ($selector.length > 0) {
                                    txt = $selector
                                        .closest('.card_field')
                                        .find('.form-' + (errorType === 'invalid' ? 'error' : 'empty'))
                                        .text()
                                        .trim();
                                    if (txt !== '') {
                                        errorTxt = errorTxt + '<li>' + txt + '</li>';
                                    }
                                }
                            });

                            $errorContainer.html(errorTxt);
                            Odigeo.trigger('payment-manager:showErrors', 'newError');
                        }
                    },
                    onShowInvoiceManagerErrorsResume: function(errorList, opt) {
                        var $errorContainer = $payment.find('.invoicemanager_validation_errors');
                        var $errorContainerPayment = $payment.find('.paymentmanager_validation_errors');
                        var errorTxt = '';
                        var selector;
                        $errorContainerPayment.empty();
                        Odigeo._.each(errorList, function(iter) {
                            selector = '.form-' + (iter.errorType === 'invalid' ? 'invalid' : 'empty');
                            if (iter.name === 'invoice_name' || iter.name === 'invoice_id') {
                                selector = selector + ' span.' + opt;
                            }
                            var txt = $('input[name=' + iter.name + ']')
                                .parent()
                                .find(selector)
                                .text()
                                .trim();
                            errorTxt = errorTxt + '<li>' + txt + '</li>';
                        });
                        $errorContainer.html(errorTxt);

                        Odigeo.trigger('payment-manager:showErrors', 'newError');
                    },
                    onInvoiceManagerClearValidationErrors: function() {
                        $payment.find('.invoicemanager_validation_errors').html('');
                    },

                    onShowErrors: function() {
                        fieldUtils.scrollToFirstError($payment);
                    },

                    onNoPaymentMethodsAvailable: function() {
                        Odigeo.UIElements.showBrokenFlowError();
                    },

                    cleaningDpWaitingPage: function() {
                        $mainContainer.removeClass('od-process-dpwaiting');
                        $logo.removeClass('disabled');
                    },
                    hiddenPageOverDpWaitingPage: function() {
                        $mainContainer.addClass('od-process-dpwaiting');
                        $logo.addClass('disabled');
                    },

                    onExpirationDateChange: function($montSelect) {
                        if ($montSelect.attr('name') !== 'cardExpirationMonth') {
                            return;
                        }
                        var date = new Date();
                        var $yearSelect = $('select[name="cardExpirationYear"] option').eq(1);
                        var month = date.getMonth() + 1;
                        var val = parseInt($montSelect.val(), 10);

                        if (val < month) {
                            $yearSelect.attr('disabled', 'disabled');
                        } else {
                            $yearSelect.removeAttr('disabled');
                        }
                    },
                    onPassengerPageComplete: function(data) {
                        const paxComplete = buyerUtils.onPassengerPageComplete(data, hasErrors, {}, $payment);
                        hasErrors = paxComplete.hasErrors;
                    },
                    validatePaymentPage: function() {
                        const $agreement = $('#i-agree-togglebutton');
                        const agreed = $agreement.is(':checked') || Odigeo.AB.isNewUniversalTermsAndConditions;
                        const invoiceManager = widgets.getInvoiceManager();
                        const specialrequestManager = widgets.getSpecialrequestManager();
                        const paymentManager = widgets.getPaymentManager();
                        const isInvoiceValid = invoiceManager.get('isInvoiceValid', true);
                        const isIdealRequestValid = paymentManager.get('isIdealRequestValid');

                        if (isInvoiceValid) {
                            invoiceData = invoiceManager.get('getInvoiceData');
                            paymentManager.execute('setInvoiceRequestDTO', invoiceData.invoicemanager);
                        }

                        if (!Odigeo.AB.isMoveSpecialRequest) {
                            const hasSpecialRequest = specialrequestManager.get('hasSpecialRequest');
                            const isSpecialrequestValid = specialrequestManager.get('isValid');
                            if (isSpecialrequestValid && hasSpecialRequest) {
                                paymentManager.execute('setBookingUserComments', specialrequestManager.get('getSpecialRequestData'));
                            }
                            return (
                                widgets.binDetectionManager().get('isValid') &&
                                agreed &&
                                paymentManager.get('isValid') &&
                                isSpecialrequestValid &&
                                isInvoiceValid &&
                                isIdealRequestValid &&
                                !hasErrors
                            );
                        } else {
                            paymentManager.execute('setBookingUserComments', JSON.parse(Odigeo.Session.get('bookingUserComments')));

                            return (
                                widgets.binDetectionManager().get('isValid') &&
                                agreed &&
                                paymentManager.get('isValid') &&
                                isInvoiceValid &&
                                isIdealRequestValid &&
                                !hasErrors
                            );
                        }
                    },
                    showPaymentValidationErrors: function() {
                        const paymentManager = widgets.getPaymentManager();
                        const $agreement = $('#i-agree-togglebutton');
                        const agreed = $agreement.is(':checked') || Odigeo.AB.isNewUniversalTermsAndConditions;
                        if (!agreed) {
                            trackingUtils.trackEvent('confirm_purchase', 'conditions_unchecked_error');
                            Odigeo.trigger('payment-manager:showErrors', 'agree');
                        }

                        $agreement.closest('.payment_agree').attr('data-state', 'invalid');

                        Odigeo.UIElements.enhanceLoading($('.waiting_page')).hideLoading();
                        paymentManager.execute('commit', {simulate: true, showErrorsResume: true, displayErrors: true});
                        fieldUtils.scrollToFirstError($payment);
                        widgets.getPaymentManager().execute('updatePaymentOptions');
                    },

                    onShowPsd2InfoMsg: function(europeanCard) {
                        widgets.getPaymentManager().execute('onShowPsd2InfoMessage', europeanCard);
                    },

                    onOpenPsd2Communication: function() {
                        widgetLoader.get('psd2CommunicationPopup').execute('open');
                    },

                    onShowFlightDetails() {
                        asyncWidgets.getFlightSummary().execute('toggleFlightDetails');
                    },
                    totalPriceUpdated(priceCollection) {
                        widgetLoader.get('paymentButton').execute('storeTotalTicketPrice', priceCollection.totalPrice);
                        this.refreshOfferPricesTextSize();
                    },
                    onGetMembershipInfo() {
                        widgetLoader
                            .get('membershipAncillaries')
                            .get('getMembershipInfo')
                            .then(() => {
                                asyncWidgets.getSidebar().execute('refreshSmoothSidebar', {page: 'payment'});
                            });
                    },
                    membershipAncillariesTracking(isPaymentButton) {
                        const isSubscriptionAdded = this.isSubscriptionAdded();
                        const flightSelectionData = Odigeo.Utils.parseJson(Odigeo.Session.get('flightSelectionData'));
                        const isFullFareSelected = Odigeo._.get(flightSelectionData, 'data.priceWithoutDiscountSelected', false) || false;
                        const fare = isSubscriptionAdded ? 'prime' : 'standard';
                        const primeFareSelectedLabel = isFullFareSelected ? 'no-prime' : 'prime';
                        const trackingInfo = `${primeFareSelectedLabel}${isUserLogged() ? '-log' : ''}`;
                        const payPage = isDynpack ? 'dp-pay' : 'pay';
                        const ancPage = isDynpack ? 'dp-anc' : 'anc';
                        trackingUtils.trackEventWithCategory(
                            'flights_ancillaries_page',
                            'prime',
                            `continue_with_${fare}_sce:${trackingInfo}_pag:${isPaymentButton ? payPage : ancPage}`
                        );
                    },
                    isSubscriptionAdded() {
                        let isSubscriptionAdded;
                        if (Odigeo.Membership.isMembershipProductEnabledDesktop && !Odigeo.Membership.isFreeTrialMetaRevampDesktop) {
                            isSubscriptionAdded = widgetLoader.get('membershipAncillaries').get('isSubscriptionAdded');
                        } else {
                            const membershipProductPreviousRequest = Odigeo.Utils.parseJson(Odigeo.Session.get('membershipProductPreviousRequest'));
                            isSubscriptionAdded = !Odigeo._.isNull(membershipProductPreviousRequest)
                                ? membershipProductPreviousRequest.quantity > 0
                                : false;
                        }
                        return isSubscriptionAdded;
                    },
                    onIsAutoApplyDiscount(isAutoApplyDiscount) {
                        if (Odigeo.AB.sidebarRevamp && !Odigeo.Membership.isMembershipAutoApplyDiscount) {
                            dispatch({type: SET_PRIME_MEMBER_SELECTED, entry: {}, merge: true});
                        }
                        asyncWidgets.getPriceManagerEnhanced().execute('showAutoApplyDiscountLabel', isAutoApplyDiscount);
                    },
                    onTrackCustomDimensionSidebar(priceOnlyFlightAmount) {
                        if (readyForTrackingCustom54 && !hasLaunchTrackingCustomDimension54) {
                            trackingUtils.trackPage(PAGE, {
                                funnel: true,
                                customDimensions: {
                                    transaction_price: '' + priceOnlyFlightAmount,
                                },
                            });
                            custom54ValueTotalPrice = priceOnlyFlightAmount;
                            hasLaunchTrackingCustomDimension54 = true;
                        }
                    },
                    onFastTrackToggle({selected, data}) {
                        const passengersData = Odigeo.Session.get('passengersData') || [];
                        const passengers = Odigeo.Utils.parseJson(passengersData);
                        delete passengers.buyer;
                        const passengersLength = Object.keys(passengers).length;
                        ShoppingCart.builders.fastTrack
                            .id(data.type, data.id)
                            .data({
                                ...data,
                                price: {
                                    total: data.price.total * passengersLength,
                                },
                                policy: FT,
                                type: AIRPORT_FAST_TRACK,
                            })
                            .from(ShoppingCart.sources.actions.USER_REQUESTED, ShoppingCart.sources.targets.WIDGET)
                            .toggle(selected);

                        const priceItem = {
                            allPrice: data.price.total * passengersLength,
                            allowMultipleOfTheSameType: true,
                            conceptKey: FT,
                            conceptLabel: data.concept,
                            onePrice: data.price.total,
                            policy: FT,
                            quantity: passengersLength,
                            type: AIRPORT_FAST_TRACK,
                        };
                        if (selected) {
                            const existingItem = priceCollection.getPriceBreakdownItemByPolicyOrId(priceItem.policy);
                            if (existingItem) {
                                priceCollection.removeItemByType(AIRPORT_FAST_TRACK);
                            }
                            priceCollection.addItem(priceItem);
                        } else {
                            priceCollection.removeItemByType(AIRPORT_FAST_TRACK);
                        }
                    },
                    onCanxselfToggleOF2({data, selected}) {
                        ShoppingCart.builders.insurance
                            .id(data.type, data.id)
                            .data(data)
                            .from(ShoppingCart.sources.actions.USER_REQUESTED, ShoppingCart.sources.targets.WIDGET)
                            .toggle(selected);

                        const priceItem = {
                            allPrice: data.price.total,
                            allowMultipleOfTheSameType: false,
                            conceptKey: '',
                            conceptLabel: data.concept,
                            onePrice: data.price.total,
                            policy: data.type,
                            quantity: 1,
                            type: data.extra.insuranceType,
                        };
                        if (selected) {
                            const existingItem = priceCollection.getPriceBreakdownItemByPolicyOrId(priceItem.policy);
                            if (existingItem) {
                                priceCollection.removeItemByType(priceItem.type);
                            }
                            priceCollection.addItem(priceItem);
                        } else {
                            priceCollection.removeItemByType(priceItem.type);
                        }
                    },
                    onTravelInsuranceSelectionChangeOF2({data: insuranceData, selected}) {
                        this.removeCurrentSelectedTravelInsurances();

                        if (insuranceData && selected) {
                            this.addTravelInsurance({
                                conceptLabel: insuranceData.conceptLabel,
                                id: insuranceData.id,
                                offerId: insuranceData.offerId,
                                price: insuranceData.totalPrice.value.amount,
                            });
                        }
                    },
                    addTravelInsurance({offerId, id, conceptLabel, price}) {
                        const passengersData = Odigeo.Session.get('passengersData') || [];
                        const passengers = Odigeo.Utils.parseJson(passengersData);
                        delete passengers.buyer;
                        const passengersLength = Object.keys(passengers).length;

                        ShoppingCart.builders.insurance
                            .id(offerId, id)
                            .data({
                                committable: false,
                                id: id,
                                type: offerId,
                                concept: conceptLabel,
                                price: {
                                    total: price,
                                },
                                extra: {
                                    insuranceType: TRAVEL_INSURANCE_TYPE,
                                }})
                            .from(ShoppingCart.sources.actions.USER_REQUESTED, ShoppingCart.sources.targets.WIDGET)
                            .toggle(true);

                        priceCollection.addItem({
                            allPrice: price,
                            allowMultipleOfTheSameType: false,
                            conceptKey: '',
                            conceptLabel: conceptLabel,
                            id: id,
                            onePrice: price,
                            policy: offerId,
                            quantity: passengersLength,
                            type: TRAVEL_INSURANCE_TYPE,
                        });
                    },
                    removeCurrentSelectedTravelInsurances() {
                        const selectedProducts = ShoppingCart.take.insurances((item) => item.extra.insuranceType === TRAVEL_INSURANCE_TYPE);

                        if (selectedProducts) {
                            selectedProducts.forEach((selectedProduct) => {
                                ShoppingCart.builders.insurance
                                    .id(selectedProduct.policy, selectedProduct.id)
                                    .from(ShoppingCart.sources.actions.USER_REQUESTED, ShoppingCart.sources.targets.WIDGET)
                                    .toggle(false);

                                priceCollection.removeItem(selectedProduct);
                            });

                            priceCollection.removeItem(priceCollection.getPriceBreakdownItemsByType(TRAVEL_INSURANCE_TYPE));
                        }
                    },
                }),
            }
        );

        if (Odigeo.AB.isDpSearchInSecure && Dynpack.isPreparedToLaunchSearchInSecure()) {
            Odigeo.Router.eventController.execute();
            Odigeo.trigger('dpsearch-manager:retryDynpackDeeplink');
            return;
        }

        widgets.nagManager().execute('updateState');

        // Retrieve service options table
        trackingUtils.startMetric(PLUS_LOAD_SO_TABLE);

        if (!Odigeo.AB.isMoveProductsModule) {
            trackingUtils.startMetric(AncillariesModuleGrafanaConstants.getLoadMetricKey(PAGE));

            if (Odigeo.AB.isAutomaticCheckInHandLuggageOnlyDesktop) {
                ancillariesModuleBaggage().then((baggageData) => {
                    asyncWidgets.getAncillariesModule().execute('clearData', baggageData).then(() => {
                        asyncWidgets.getAncillariesModule().execute('fetchData');
                        asyncWidgets.getAncillariesModule().execute('trackBaggage', baggageData);
                    });
                });
            } else {
                asyncWidgets.getAncillariesModule().execute('clearData').then(() => {
                    asyncWidgets.getAncillariesModule().execute('fetchData');
                    ancillariesModuleBaggage().then((baggageData) => {
                        asyncWidgets.getAncillariesModule().execute('trackBaggage', baggageData);
                    });
                });
            }

            trackingUtils.startMetric(AncillariesModuleGrafanaConstants.getLoadMetricKey('paymentFlex'));
            asyncWidgets.getAncillariesDebugInfo().execute('load');

            asyncWidgets.getServiceoptionsTableManager().execute('load');
        }

        widgetLoader.get('paymentButton').execute('forceLoad', (model) => {
            asyncWidgets.getPriceManagerEnhanced().execute('hideTotalPriceContainer', model.mustHideTotalPrice);
        });

        $window.resize(Odigeo._.throttle(function() {
            asyncWidgets.getServiceoptionsTableManager().execute('alignTableCellsHeight');
        }, 50));

        // Initializing flight details
        if ($flightDetails.hasClass('hidden')) {
            Odigeo.UIElements.hideAllDialogs();
            $flightDetails.removeClass('hidden');
        }

        Odigeo._.each($persuasionMessagePopup, function(message) {
            Odigeo.UIElements.hint.enhance(Odigeo.History.getPageNameFromFragment(), message, {events: {tap: true}});
        });

        Odigeo.Router.eventController.execute();

        Odigeo.Utils.sessionTimer.reset();

        // Retrieve payment options
        widgets.getPaymentManager().execute('updatePaymentOptions');

        paymentGeneric.isLoggedIn();

        if (!Odigeo.AB.isMoveProductsModule) {
            // Ancillary step
            ancillariesStep.init();
            serviceOptionsStep.enable();
        }

        // Hide loading
        if (isDynpack) {
            if (Odigeo.Session.get('before-page') !== 'tap-details') {
                widgets.dpWaitingPage().execute('activate');
            }
        } else {
            Odigeo.UIElements.enhanceLoading($('.waiting_page')).hideLoading();
        }

        if (!Odigeo._.isNull(lastRoute) && lastRoute.from.name === 'confirmation') {
            if (!widgets.getPaymentManager().isPaymentMethodRetry && !widgets.getPaymentManager().isRepricing) {
                widgets.getPaymentManager().bookingAlreadyDone = true;
                Odigeo.UIElements.showBookingAlreadyDone('alert');
            }
        } else {
            Odigeo.Session.set('before-page', PAGE);
        }

        if (isSidebarSummary) {
            asyncWidgets.getSidebar().execute('updatePage', PAGE);
        }

        widgetLoader.get('login').execute('launchPriceMemberDisplay');

        trackingUtils.bindEvents($payment);

        ancillariesGeneric.windowScroll();

        // TODO: Remove the booking_pax_list part after BOOK-94 go to production
        var travellers = Odigeo.Session.get('booking_pax_list') || null;
        var persuasiveName = '';
        var storedPassengers;
        var passenger;
        if (!Odigeo._.isNull(travellers)) {
            storedPassengers = Odigeo.Utils.parseJson(travellers);
            passenger = Odigeo._.filter(storedPassengers, {travellerId: '1'});
            persuasiveName = passenger[0].name;
        } else {
            travellers = Odigeo.Session.get('passengersData') || null;
            if (!Odigeo._.isNull(travellers)) {
                storedPassengers = Odigeo.Utils.parseJson(travellers);
                persuasiveName = storedPassengers.passengers1.name;
            }
        }
        if (!Odigeo._.isEmpty(persuasiveName) && Odigeo._.size($persuasiveTitleWithName) > 0) {
            $persuasiveTitleName.html(persuasiveName);
            $persuasiveTitleWithoutName.addClass('hidden');
            $persuasiveTitleWithName.removeClass('hidden');
        }

        changeTab.init('flights_pay_page');

        trackingUtils.stopMetric('LOAD_PAYMENTS_DESKTOP');
        sessionManagement.refreshSession(bookingid + '', PAGE);

        handler3DS.initHandler(paymentHandlerResponse);
        paymentGeneric.psd2Restore();

        widgetLoader.get('cartDebugger').execute('load');
        widgetLoader.get('delayCompensation').execute('load');
        widgetLoader.get('ancillariesSummary').execute('load');
        widgetLoader.get('paymentSidebar').execute('render');
        widgetLoader.get('paymentButton').execute('toggleButtons', false);
        widgetLoader.get('blockRiskyCards');
        widgetLoader.get('blockExpiringCards');
        loadAtolWidgets(['atol-protected-payment-footer-tooltip']);
        vinFlightsTracking.trackFlowOnLoad();
        widgetLoader.get('membershipAutoApplyDiscount');
    };

    trackingPageFlowUtils.registerPage({
        id: PAGE,
        flow: 'payment_flow_appearances',
        label: 'pay:ap',
    });

    function setFocusEventWindowMultitab(bookingId) {
        if (Odigeo.AB.isDynpackDesktopMultiTab) {
            setTabFocusEvent(true, bookingId);
        }
    }
    function setDPPricingUtils() {
        dispatch({type: SET_IS_META, entry: Odigeo.SessionScope.isMeta});
        dispatch({type: SET_CURRENT_PAGE, entry: Odigeo.History.getPageNameFromFragment()});
    }
}());
